<template>
  <input-select
    v-model="proxyValue"
    :items="items"
    :loading="isLoading"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import RequestSelectMixin from 'Arch/mixins/RequestSelectMixin';

export default {
  name: 'InputSelectRequest',
  mixins: [RequestSelectMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    propValue: {
      type: String,
      default: 'id',
    },
    propText: {
      type: String,
      default: '',
    },
    faultMessage: {
      type: String,
      default: '',
    },
    requestClass: {
      type: [Function, Promise],
      default() {
        return () => Promise.resolve({});
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    items: [],
    selectLoading: false,
  }),
  computed: {
    proxyValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
      },
    },
    isLoading() {
      return this.loading || this.selectLoading;
    },
    getRequest() {
      return this.requestClass;
    },
    getMessage() {
      return this.faultMessage;
    },
    propKey() {
      return this.propValue;
    },
    getText() {
      return this.propText;
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.selectLoading = !this.selectLoading;
    },
    makeRequest() {
      this.serviceCall(
        this.getRequest(
          this.makeParams(),
        ),
        this.setDataOptions(
          'items',
          this.getText,
        ),
        this.getMessage,
        this.propKey,
        this.handleLoading,
      );
    },
  },
};
</script>
